import "./style.scss";
import * as React from "react";
import { Menu, Popover, Icon } from "antd";
import Feature from "../../../../../modules/common/components/Feature";

const MenuItem = Menu.Item;

interface MetricsSideMenuItemContentsProps {
  header?: string;
  subheader?: any;
  metric?: any;
}

export class SideMenuItemContents extends React.Component<
  MetricsSideMenuItemContentsProps,
  {}
> {
  render() {
    return (
      <div
        className="side-menu-item-contents"
        data-automation-id={`side-menu-${this.props.header.toLowerCase().replace(" ", "-")}`}
      >
        <div className="metric-name">
          {this.props.header}
          &nbsp;&nbsp;&nbsp;
          <Popover
            arrowPointAtCenter
            placement="topLeft"
            title="Help"
            trigger="hover"
            content={generatePopover(this.props.metric)}
          >
            <Icon type="question-circle" />
          </Popover>
        </div>
        <div className="metric-count">{this.props.subheader}</div>
      </div>
    );
  }
}

const generatePopover = (metric: string) => {
  switch (metric) {
    case "spend":
      return (
        <span>
          Amounts provided here are in local currency and do not include the
          applicable taxes,
          <br />
          if any, and may differ from invoices as a result of billing
          adjustments
        </span>
      );
    case "impressions":
      return (
        <span>
          The total number of times your publication was visible to users.
          <br />
          Note: Impressions are not available for publications on retailer
          website or Flipp Web.
        </span>
      );
    case "opens":
      return (
        <span>The total number of times your publication was opened. </span>
      );
    case "unique_engaged_visits":
      return (
        <span>
          The total number of visitors who opened the publication and spent a
          minimum of 6 seconds
          <br />
          or performed an action such as zooming, panning or clicking on an
          item.
        </span>
      );
    case "clicks":
      return (
        <span>
          The total number of clicks that show interaction with an item
          including clicking an item,
          <br />
          sharing an item, and adding to shopping list.
        </span>
      );
    case "shopping_list":
      return (
        <span>
          The total number of items in your publication that users added to
          their shopping list.{" "}
        </span>
      );
    case "ttm":
      return (
        <span>
          The total number of clicks from the publication to your retailer
          website.
        </span>
      );
    case "average_time_on_flyer":
      return (
        <span>
          The average time in seconds, users spent on the publication per
          session.
        </span>
      );
    case "item_views":
      return (
        <Feature flag="storefronts_reporting" placeholder={itemViewHover}>
          {hostedOnlyItemViewHover}
        </Feature>
      );
  }
};

const itemViewHover = (
  <span>
    The total number of views the items in your publication received from the
    users.
  </span>
);
const hostedOnlyItemViewHover = (
  <span>
    The total number of views the items in your publication received from the
    users.
    <br />
    Item views are non-unique meaning that a page can be viewed multiple times
    in a single session.
  </span>
);



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/common/SideMenuItemContents/index.tsx